// @flow
import React, { type Node } from 'react';
import './BrandingTemplate.scss';

type Props = {
  children: Node,
};

const BrandingTemplate = ({ children }: Props) => (
  <div className="BrandingTemplate">{children}</div>
);

export default BrandingTemplate;



// WEBPACK FOOTER //
// ./src/components/branding/BrandingTemplate/BrandingTemplate.js